import { render, staticRenderFns } from "./certificateService.vue?vue&type=template&id=426c74d7&scoped=true"
import script from "./certificateService.vue?vue&type=script&lang=js"
export * from "./certificateService.vue?vue&type=script&lang=js"
import style0 from "./certificateService.vue?vue&type=style&index=0&id=426c74d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426c74d7",
  null
  
)

export default component.exports